<div class="e-filter-tabs" [cdkTrapFocus]="isOverlay && showFilters" (keydown.escape)="toggleFilters(false)">
    <via-loading-spinner *ngIf="loading"></via-loading-spinner>

    <div class="e-filter-modal-header" *ngIf="isOverlay && showFilters">
        <h1>{{ getActiveTabTitle() }}</h1>
        <button (click)="toggleFilters(false)">Close <i class="fa-solid fa-xmark"></i></button>
    </div>

    <div role="region" aria-label="Switch between different filter dimensions">
        <div class="e-filter-tabs-heading">
            <div>
                <h3>{{ tabsTitle }}</h3>
                <via-info-icon [tooltipText]="filterTabsTooltip"></via-info-icon>
            </div>
            <div>
                <button class="e-filters-reset-button" [disabled]="resetButtonDisabled ? 'disabled' : null" (click)="resetFilters()">
                    <i class="fas fa-trash-alt"></i> Reset filters
                </button>
                <via-info-icon [tooltipText]="resetFiltersButtonTooltip"></via-info-icon>
            </div>
        </div>
        <div class="e-tab-buttons" role="tablist" (keydown)="tabKeyEvents($event)">
            <button
                *ngFor="let tab of filterTabs; let i = index"
                role="tab"
                #tabButton
                (click)="changeTab(tab.id)"
                (focus)="setFocusTab()"
                id="tab-button-{{ tab.id }}"
                attr.aria-controls="tab-content-{{ tab.id }}"
                [class.e-tab-active]="activeTabId === tab.id"
                [disabled]="tab.disabled || disableAllFilters"
                [attr.aria-selected]="activeTabId === tab.id"
                [attr.aria-disabled]="tab.disabled"
                [attr.aria-setsize]="filterTabs.length"
                [attr.aria-posinset]="i + 1"
                [attr.tabindex]="i === 0 ? 0 : -1">
                <span *ngIf="tab.selectedCount > 0" class="e-filter-tab-count">
                    {{ tab.selectedCount }}
                </span>
                <div *ngFor="let label of tab.labels" class="e-filter-tab-title">
                    {{ label.title }} <span *ngIf="label.state">{{ label.state }}</span>
                </div>
            </button>
        </div>
    </div>

    <div class="e-filter-tabs-selection-container" *ngIf="showFilters">
        <div class="e-selection-container" role="region" aria-label="Make your filter selections">
            <div class="e-selection-controls">
                <div
                    *ngFor="let tab of filterTabs"
                    role="tabpanel"
                    id="tab-content-{{ tab.id }}"
                    attr.aria-labelledby="tab-button-{{ tab.id }}">
                    <ng-container *ngIf="activeTabId === tab.id">
                        <ng-container [ngSwitch]="tab.labels[0].title">
                            <via-filter-countries
                                *ngSwitchCase="'Countries'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                (onApplyClicked)="navigateToCategoriesTab()"
                                [isOverlay]="isOverlay">
                            </via-filter-countries>
                            <via-filter-categories
                                *ngSwitchCase="'Categories'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-categories>
                            <via-filter-suppliers
                                *ngSwitchCase="'Suppliers'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-suppliers>
                            <via-filter-brands
                                *ngSwitchCase="'Brands'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-brands>
                            <via-filter-attribute-types
                                *ngSwitchCase="'Attribute Types'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-attribute-types>
                            <via-filter-attributes
                                *ngSwitchCase="'Attributes'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-attributes>
                            <via-filter-retailer-types
                                *ngSwitchCase="'Retailer Types'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-retailer-types>
                            <via-filter-retailers
                                *ngSwitchCase="'Retailers'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-retailers>
                            <via-filter-tab-configuration
                                *ngSwitchCase="'Date Range'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-tab-configuration>
                            <via-filter-promotions
                                *ngSwitchCase="'Promotions'"
                                [(showApplyButton)]="disableApplyButton"
                                [applyClicked]="applyClicked"
                                [cancelClicked]="cancelClicked"
                                [isOverlay]="isOverlay">
                            </via-filter-promotions> 
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="e-your-selections-container">
                <via-filter-selections [currentTab]="activeTabId"></via-filter-selections>
            </div>
        </div>
        <div class="e-action-bar">
            <via-sku-count [displaySkuCount]="displaySkuCount" [message]="skuCountMessage"></via-sku-count>
            <via-action-bar
                [showApplyButton]="true"
                [showCancelButton]="isOverlay"
                [disableApplyButton]="disableApplyButton"
                [applyButtonText]="'Apply Filters'"
                [showBackButton]="false"
                [nextButtonText]="'Configure Data'"
                (onApplyClicked)="applyFilters()"
                [isNextButtonHidden]="nextButtonIsHidden || isOverlay"
                (onCancelClicked)="cancelChanges()"
                [hasPreviousSelections]="previouslySelectedFilters > 0"></via-action-bar>
        </div>
    </div>
</div>
